<template>
  <nav class="renewal-navbar">
    <img
      src="@/assets/images/pngs/epaylater-logo.png"
      alt="ePayLater"
      class="renewal-navbar__logo"
    />
  </nav>
</template>
<script>
export default {
  name: "RenewalNavbar"
};
</script>
<style lang="scss" scoped>
.renewal-navbar {
  background: #fff;
  padding: 18px 20px;
  &__logo {
    height: 24px;
    width: auto;
  }
}
</style>
